import { render, staticRenderFns } from "./ProspectContactCreate.vue?vue&type=template&id=19a25480"
import script from "./ProspectContactCreate.vue?vue&type=script&lang=ts"
export * from "./ProspectContactCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports